import React from 'react';
import c from 'classnames';

import type { MenuItem } from '@uncinc/react-drupal-core/types';
import type { MenuItemWrapperProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import { useMegaMenuContext } from '../../../../context/MegaMenuContext';

const MegaMenuSubMenuItemWrapper: React.FC<MenuItemWrapperProps> = ({
  level,
  className,
  children,
  buildMenu,
}) => {
  const { expandedMenuItem } = useMegaMenuContext();

  return (
    <ul className={c(`RecursiveMenu__layer__${level}`, className)}>
      {children.map((item: MenuItem) => {
        // This makes sure we only render the submenu of the
        // expanded top menu item, and not everything else.
        if (level === 0 && item.link.id !== expandedMenuItem) {
          return null;
        }

        return buildMenu(item);
      })}
    </ul>
  );
};

export default MegaMenuSubMenuItemWrapper;
